import React from "react";
import { Section } from "./Section";
import {
  Cloud,
  Server,
  ShieldCheck,
  Settings2,
  HeadphonesIcon,
  Network,
  Bot,
  Workflow,
  Github,
} from "lucide-react";

const SERVICES = [
  {
    id: "svc-cloud",
    icon: Cloud,
    title: "Cloud Services",
    description:
      "AWS, Azure and GCP — architected, migrated and run by engineers who answer the phone at 3am.",
  },
  {
    id: "svc-enterprise",
    icon: Server,
    title: "Enterprise IT",
    description:
      "End-to-end infrastructure: virtualisation, storage, networking and disaster recovery.",
  },
  {
    id: "svc-managed",
    icon: HeadphonesIcon,
    title: "Managed Services",
    description:
      "24/7/365 monitoring, patching and incident response with a 15-minute response window.",
  },
  {
    id: "svc-cyber",
    icon: ShieldCheck,
    title: "Cybersecurity",
    description:
      "Zero-trust architectures, SOC services, vulnerability management and compliance.",
  },
  {
    id: "svc-devops",
    icon: Settings2,
    title: "DevOps & CI/CD",
    description:
      "Jenkins, GitLab, Docker and Kubernetes pipelines that ship safely, dozens of times a day.",
  },
  {
    id: "svc-network",
    icon: Network,
    title: "Networking",
    description:
      "SD-WAN, VPN, firewall and load-balancing for resilient, global connectivity.",
  },
  {
    id: "svc-agentic",
    icon: Bot,
    title: "Agentic AI",
    description:
      "Production-grade AI agents that triage tickets, summarise incidents and automate the boring parts of ops.",
  },
  {
    id: "svc-automation",
    icon: Workflow,
    title: "Automations",
    description:
      "Workflow automation across ITSM, identity, billing and procurement — fewer tickets, faster outcomes.",
  },
  {
    id: "svc-github",
    icon: Github,
    title: "GitHub",
    description:
      "GitHub Enterprise rollouts, Copilot adoption programs and seamless migrations from legacy SCM.",
  },
];

export const Services = () => {
  return (
    <Section id="services" className="bg-zinc-950 py-24 lg:py-32 border-t border-white/5">
      <div className="reveal-up max-w-2xl">
        <div className="text-xs uppercase tracking-[0.22em] text-[#FF4500] font-semibold">
          What we do
        </div>
        <h2
          className="mt-4 text-4xl sm:text-5xl font-black tracking-[-0.02em] text-white"
          style={{ fontFamily: "Outfit, sans-serif" }}
        >
          A complete stack of IT services,
          <br />
          run by one accountable team.
        </h2>
      </div>

      <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10 rounded-2xl overflow-hidden">
        {SERVICES.map((svc) => {
          const Icon = svc.icon;
          return (
            <div
              key={svc.id}
              data-testid={svc.id}
              className="reveal-up bg-zinc-950 p-8 lg:p-10 hover:bg-zinc-900 transition-colors duration-200 group"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-white/5 text-white group-hover:bg-[#FF4500] transition-colors duration-200">
                <Icon className="w-5 h-5" strokeWidth={1.75} />
              </div>
              <h3
                className="mt-6 text-xl font-bold tracking-tight text-white"
                style={{ fontFamily: "Outfit, sans-serif" }}
              >
                {svc.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-zinc-400">
                {svc.description}
              </p>
            </div>
          );
        })}
      </div>
    </Section>
  );
};

export default Services;
